function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.75.75l-4.5 4.5 1.5 1.5L15 1.5V.75h-2.25zM7.5 7.875a.375.375 0 110-.75.375.375 0 010 .75zM3 13.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm2.73-.27C5.902 3.855 6 3.442 6 3a3 3 0 10-3 3c.442 0 .855-.097 1.23-.27L6 7.5 4.23 9.27A2.923 2.923 0 003 9a3 3 0 103 3c0-.442-.098-.855-.27-1.23L7.5 9l5.25 5.25H15v-.75L5.73 4.23z",
  fillRule: "nonzero",
  fill: "#2C3137"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default SvgComponent;